import * as tslib_1 from "tslib";
import React from 'react';
import Field from './Field';
import DatePicker from '@sinoui/datepicker';
var DatePickerFieldInner = /** @class */ (function (_super) {
    tslib_1.__extends(DatePickerFieldInner, _super);
    function DatePickerFieldInner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (event, value) {
            _this.props.form.setFieldValue(_this.props.props.name, value);
            _this.onBlur(event, value || '');
            if (_this.props.props.onChange) {
                _this.props.props.onChange(value, _this.props.form);
            }
        };
        _this.onBlur = function (event, value) {
            clearTimeout(_this.blurTimerId);
            if (event) {
                event.persist();
            }
            _this.blurTimerId = setTimeout(function () {
                _this.props.form.setFieldTouched(_this.props.props.name, true);
                _this.props.field.onBlur(event || {
                    persist: function () { return 0; },
                    target: {
                        name: _this.props.props.name,
                        value: typeof value !== 'undefined'
                            ? value
                            : _this.props.form.values[_this.props.props.name],
                    },
                });
            }, 100);
        };
        return _this;
    }
    DatePickerFieldInner.prototype.render = function () {
        var _a = this.props, props = _a.props, field = _a.field, form = _a.form;
        return (React.createElement(DatePicker, tslib_1.__assign({}, props, field, { error: !!(form.touched[field.name] && form.errors[field.name]), id: field.name, value: field.value ||
                (props.value && form.setFieldValue(field.name, props.value)) ||
                '', hideIcon: props.readOnly || props.disabled, onChange: this.onChange, onBlur: this.onBlur, onlyYearMonth: props.onlyYearMonth })));
    };
    return DatePickerFieldInner;
}(React.Component));
/**
 * 选择框组件
 */
export default function DatePickerField(_a) {
    var children = _a.children, props = tslib_1.__rest(_a, ["children"]);
    return (React.createElement(Field, tslib_1.__assign({}, props, { render: function (_a) {
            var field = _a.field, form = _a.form;
            return (React.createElement(DatePickerFieldInner, { field: field, form: form, props: props }));
        } })));
}
//# sourceMappingURL=DatePickerField.js.map